// extracted by mini-css-extract-plugin
module.exports = {"appTable":"AppTable_appTable__Ck3q9"};